////////////////////////////////////////////////////////////////////////////
// FL object
window.fl = window.fl || {};
window.fl["a2hs"] = window.fl["a2hs"] || {};

window.fl.a2hs.deferredPrompt = null;
window.fl.a2hs.button = null;

window.fl.a2hs.init = () => {
  window.fl.a2hs.button = document.getElementById("a2hs") || null;
  if (window.fl.a2hs.button) {
    window.fl.a2hs.button.style.display = "none";
    window.addEventListener("beforeinstallprompt", (e) => {
      window.fl.a2hs.deferredPrompt = e;
      window.fl.a2hs.button.style.display = "block";
    });
    window.addEventListener('appinstalled', (event) => {
      console.log('👍', 'appinstalled', event);
    });
  }
};

window.fl.a2hs.add = () => {
  console.log("a2hs add");
  if (window.fl.a2hs.deferredPrompt) {
    window.fl.a2hs.button.style.display = "none";
    window.fl.a2hs.deferredPrompt.prompt();
    window.fl.a2hs.deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the A2HS prompt");
      } else {
        console.log("User dismissed the A2HS prompt");
      }
      window.fl.a2hs.deferredPrompt = null;
    });
  }
};

window.fl.a2hs.init();
